import React from 'react';
import {
  Button,
  SnapDialog,
  TextField,
  SecuredTextField
} from '@one-snap/sparkles';
import PropTypes from 'prop-types';
import './AwarenessPageStyles.css';
import Footbar from './Footbar';
import CartAmountHeader from './CartAmountHeader';

function PersonalInfoPage({
  isVisible,
  onClose,
  totalAmount,
  goBack,
  onContinue
}) {
  return (
    <SnapDialog
      open={isVisible}
      onClose={onClose}
      className="custom-dialog-sm-width"
    >
      <div className="verification-page-div">
        <CartAmountHeader
          totalAmount={totalAmount}
          goBack={goBack}
          showCartAmount
        />
        <div className="awareness-content">
          <div className="lto-mob-vcode-1">Tell us about yourself</div>
          <br />
          <div className="personal-info-title">Name</div>
          <div className="personal-info-form">
            <div className="name-section">
              <TextField
                label="First Name"
                defaultValue="John"
                className="personal-info-tab-space"
                style={{ width: '49%' }}
              />
              <TextField
                label="Last Name"
                defaultValue="Doe"
                style={{ width: '48%' }}
              />
            </div>
            <br />
            <div className="personal-info-title">
              Home address (No PO Boxes)
            </div>
            <div className="address-section">
              <TextField
                label="Street Address"
                defaultValue="123 Main St. San Jose, CA 95128"
                className="personal-info-tab-space"
                style={{ width: '49%' }}
              />
              <TextField
                label="Unit (Optional)"
                placeholder="Unit (Optional)"
                style={{ width: '48%' }}
              />
            </div>
            <br />
            <div className="personal-info-title">Email</div>
            <div className="email-section">
              <TextField
                label="Email Address"
                defaultValue="test@snapfinance.net"
                style={{ width: '100%' }}
              />
            </div>
            <br />
            <div className="personal-info-title">Identity Verification</div>
            <div className="identity-verification-section">
              <SecuredTextField
                label="Date of Birth"
                value="07/07/1977"
                definitionMask="*"
                className="personal-info-btm-space"
                style={{ width: '100%' }}
                maskedValue={false}
                mask="XX/XX/XX77"
              />
              <br />
              <SecuredTextField
                label="SSN or ITIN"
                value="976-90-8619"
                definitionMask="*"
                style={{ width: '100%' }}
                maskedValue={false}
                mask="XXX-XX-XX19"
              />
            </div>
          </div>
          <br />
          <Button className="continue-button" onClick={onContinue}>
            Continue
          </Button>
          <Footbar />
        </div>
      </div>
    </SnapDialog>
  );
}

PersonalInfoPage.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  goBack: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  totalAmount: PropTypes.string.isRequired
};

export default PersonalInfoPage;
